import React from 'react';
import { BeforeAfterAndBonuses, GuaranteeAndCost, PainAndTransformation, ProductOverview, SocialAndFAQ, Testimonials } from './components/ContentSections';
import { FloatingElements } from './components/Floating';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { FinalCTA, Pricing, Upsell } from './components/Offers';
import { TopBar } from './components/TopBar';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-canvas text-slate-600 selection:bg-primary selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <TopBar data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Testimonials data-id="element-5" />
        <PainAndTransformation data-id="element-6" />
        <ProductOverview data-id="element-7" />
        <BeforeAfterAndBonuses data-id="element-8" />
        <Pricing data-id="element-9" />
        <Upsell data-id="element-10" />
        <SocialAndFAQ data-id="element-11" />
        <GuaranteeAndCost data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <FloatingElements data-id="element-15" />
      <noscript data-id="element-16">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=3123699361155808&ev=PageView&noscript=1" alt="" data-id="element-17" />
      </noscript>
    </div>;
}